import { FloatButton } from "antd"
import { QuestionCircleOutlined } from '@ant-design/icons';
import FacebookHelpToolTips from "./facebook-help-tooltips";

const HelpTooptipsGroup: React.FC = () => {
  return (
    <FloatButton.Group
      icon={<QuestionCircleOutlined />}
      trigger="click"
      placement="bottom"
      style={{
        position: "absolute",
        bottom: -48,
        right: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <FacebookHelpToolTips/>
    </FloatButton.Group>
  )
}

export default HelpTooptipsGroup;